/**
 * Checks if two bounds are overlapping. Return true if they overlap, false otherwise.
 * Rectangles that share the same border (ie. rect1.right & rect2.left) is considered NOT an overlap.
 * @param rect1 first set of bounds
 * @param rect2 second set of bounds
 */
export default function areBoundsOverlapped(
    rect1: { top: number; left: number; bottom: number; right: number },
    rect2: { top: number; left: number; bottom: number; right: number }
): boolean {
    return (
        rect1.top < rect2.bottom &&
        rect1.bottom > rect2.top &&
        rect1.left < rect2.right &&
        rect1.right > rect2.left
    );
}
